import { Component, OnInit } from "@angular/core";
import { UserService } from "../services/user.service";
import { OfframpService } from "../services/offramp.service";
import { Router } from "@angular/router";
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";

import { MatDialog } from "@angular/material";
import * as moment from "moment";
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { NotificationsService } from "angular2-notifications";
import { ColDef, GridOptions, GridApi, ColumnApi } from "ag-grid-community";
import { AddOfframpCapitalAllocationDialog } from "./add-offramp-capital-allocation/add-offramp-capital-allocation.component";

const defaults = {
  notif: {
    timeOut: 3000,
    showProgressBar: true,
    pauseOnHover: false,
    clickToClose: true,
    maxLength: 50,
  },
};

@Component({
  selector: "app-offramp-capital-allocation",
  templateUrl: "./offramp-capital-allocation.component.html",
  styleUrls: ["./offramp-capital-allocation.component.css"],
})
export class OfframpCapitalAllocationComponent implements OnInit {
  _csrf: string;

  private gridApi: GridApi;
  private gridColumnApi: ColumnApi;
  gridOptions: GridOptions;
  columnDefs: ColDef[] = [];
  rowData: any[] = [];
  defaultColDef: ColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    flex: 1,
    minWidth: 100
  };

  oAllocations: any = [];
  allocations: any = [];
  searchValue: string = '';
  filter: any = {
    page: 1,
    limit: 100,
  };
  prev_disabled = true;
  next_disabled = false;

  adminConfig: any[] = [];

  constructor(
    private router: Router,
    private notifSer: NotificationsService,
    private userService: UserService,
    private offrampService: OfframpService,
    private spinnerService: Ng4LoadingSpinnerService,
    public dialog: MatDialog
  ) {
    this.initializeGrid();
  }

  ngOnInit() {
    this.csrf();
  }

  configLabel(key: string): string {
    const labels: any = {
      WC_USDT_INR_RATE: 'USDT/INR Rate',
      WC_TARGET_TOTAL_CAPITAL_INR: 'Target Total Capital (INR)',
    };
    return labels[key] || key;
  }

  initializeGrid() {
    this.columnDefs = [
      {
        headerName: 'Action',
        field: 'action',
        cellRenderer: (params) => {
          if (params.node && params.node.rowPinned) {
            return document.createElement('div');
          }
          const element = params.data;
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';

          const editBtn = document.createElement('button');
          editBtn.type = 'button';
          editBtn.className = 'btn btn-sm btn-primary';
          editBtn.title = 'Edit';
          editBtn.style.marginRight = '5px';
          editBtn.innerHTML = '<i class="fa fa-edit"></i>';
          editBtn.onclick = (e) => {
            e.stopPropagation();
            this.editRecord(element);
          };
          container.appendChild(editBtn);

          const deleteBtn = document.createElement('button');
          deleteBtn.type = 'button';
          deleteBtn.className = 'btn btn-sm btn-danger';
          deleteBtn.title = 'Delete';
          deleteBtn.innerHTML = '<i class="fa fa-trash"></i>';
          deleteBtn.onclick = (e) => {
            e.stopPropagation();
            this.deleteRecord(element);
          };
          container.appendChild(deleteBtn);

          return container;
        },
        sortable: false,
        filter: false,
        flex: 1,
        minWidth: 110
      },
      {
        headerName: 'Key Person',
        field: 'adminid.name',
        valueGetter: (params) => {
          const user = params.data && params.data.adminid;
          if (!user) return '';
          return user.name || user.email || '';
        },
        cellRenderer: (params) => params.node && params.node.rowPinned ? 'Total' : (params.value || ''),
        flex: 1.2
      },
      {
        headerName: 'Platform',
        field: 'platform',
        flex: 1
      },
      { headerName: 'From Currency', field: 'from_currency', flex: 0.8 },
      { headerName: 'To Currency', field: 'to_currency', flex: 0.8 },
      {
        headerName: 'Capital Allocated',
        field: 'capital_allocated',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1
      },
      {
        headerName: 'Rate',
        field: 'rate',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 0.8
      },
      {
        headerName: 'Capital Allocated (Converted)',
        field: 'capital_allocated_convert',
        valueFormatter: (params) => this.formatNumber(params.value, 2),
        flex: 1.3
      },
      {
        headerName: 'CreatedAt',
        field: 'createdAt',
        valueFormatter: (params) => {
          if (params.value) {
            return moment(params.value).format('MMM DD, YYYY hh:mm:ss A');
          }
          return '';
        },
        flex: 1.5
      }
    ];

    this.gridOptions = {
      enableCellTextSelection: true,
      ensureDomOrder: true,
      columnDefs: this.columnDefs,
      defaultColDef: this.defaultColDef,
      rowData: this.rowData,
      pagination: false,
      suppressHorizontalScroll: false,
      enableRangeSelection: true,
      animateRows: true,
      rowHeight: 40,
      headerHeight: 40,
      getRowStyle: (params: any) => {
        if (params.node && params.node.rowPinned) {
          return { fontWeight: 'bold', background: '#f5f5f5' };
        }
        return null;
      }
    };
  }

  formatNumber(value: any, decimals: number = 2): string {
    if (value === null || value === undefined || isNaN(value)) return '';
    return Number(value).toLocaleString('en-IN', {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  }

  computeTotals(list: any[]): any {
    const totals = {
      capital_allocated: 0,
      capital_allocated_convert: 0
    };

    (list || []).forEach((allocation: any) => {
      totals.capital_allocated += allocation.capital_allocated || 0;
      totals.capital_allocated_convert += allocation.capital_allocated_convert || 0;
    });

    return totals;
  }

  updateTotalsRow() {
    if (this.gridApi) {
      this.gridApi.setPinnedBottomRowData([this.computeTotals(this.allocations)]);
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.updateTotalsRow();
  }

  csrf() {
    this.userService.csrf().subscribe(
      (success) => {
        this._csrf = success._csrf;
        this.getData();
        this.getAdminConfig();
      },
      (error) => {
        this.notifSer.error("Error", error.error.message, defaults.notif);
      }
    );
  }

  getAdminConfig() {
    this.offrampService.getAllOfframpAdminConfig({ _csrf: this._csrf }).subscribe((response: any) => {
      this.adminConfig = (response && response.data) || [];
    }, (error) => {
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch admin config", defaults.notif);
    });
  }

  goNext(type = 1) {
    if (type == 1) {
      this.filter.page++;
      this.getData();
    }
  }

  goPrev(type = 1) {
    if (type == 1) {
      if (this.filter.page > 1) {
        this.filter.page--;
        this.getData();
      }
    }
  }

  applyFilter(filterValue) {
    this.searchValue = filterValue || '';
    if (this.gridApi) {
      this.gridApi.setQuickFilter(this.searchValue);
    }
  }

  clearSearch() {
    this.searchValue = '';
    this.applyFilter('');
  }

  getData() {
    this.spinnerService.show();
    this.filter._csrf = this._csrf;
    this.offrampService.getAllOfframpCapitalAllocations(this.filter).subscribe((response: any) => {
      const list = (response && response.data) || [];
      this.allocations = list;
      this.oAllocations = list;
      this.rowData = list;

      if (this.gridApi) {
        this.gridApi.setRowData(this.rowData);
      }

      this.updateTotalsRow();
      this.spinnerService.hide();
      this.prev_disabled = this.filter.page <= 1;
      this.next_disabled = !list || list.length < this.filter.limit;
    }, (error) => {
      this.spinnerService.hide();
      this.notifSer.error("Error", (error.error && error.error.message) || "Failed to fetch capital allocations", defaults.notif);
    });
  }

  resetFilters() {
    this.filter = { page: 1, limit: 100 };
    this.searchValue = '';
    this.getData();
  }

  addNewRecord() {
    const dialogRef = this.dialog.open(AddOfframpCapitalAllocationDialog, {
      width: '600px',
      data: { record: {}, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Capital allocation added successfully", defaults.notif);
        this.getData();
      }
    });
  }

  editRecord(record: any) {
    const dialogRef = this.dialog.open(AddOfframpCapitalAllocationDialog, {
      width: '600px',
      data: { record: record, _csrf: this._csrf }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.success) {
        this.notifSer.success("Success", "Capital allocation updated successfully", defaults.notif);
        this.getData();
      }
    });
  }

  deleteRecord(record: any) {
    this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: `Are you sure you want to delete this capital allocation?`,
        buttonText: { ok: 'Yes', cancel: 'No' }
      }
    }).afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.spinnerService.show();
        this.offrampService.deleteOfframpCapitalAllocation({ _id: record._id, _csrf: this._csrf }).subscribe(
          (response: any) => {
            this.spinnerService.hide();
            if (response.status || response.success) {
              this.notifSer.success("Success", response.message || "Capital allocation deleted successfully", defaults.notif);
              this.getData();
            } else {
              this.notifSer.error("Error", response.message || "Failed to delete capital allocation", defaults.notif);
            }
          },
          (error) => {
            this.spinnerService.hide();
            this.notifSer.error("Error", (error.error && error.error.message) || "Failed to delete capital allocation", defaults.notif);
          }
        );
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/offramp-capital-allocation/offramp-capital-allocation.component.ts